import { httpsCallable } from "firebase/functions";
import getFirebase from "../firebase";

export interface WebhookSecretStatus {
    exists: boolean;
    masked: string | null;
}

const callable = (name: string) => {
    const { functions } = getFirebase();
    return httpsCallable(functions, name);
};

const WebhookSecretService = {
    generate: async (organizationId: string): Promise<{ secret: string }> => {
        const result = await callable("generateWebhookSecret")({ organizationId });
        return result.data as { secret: string };
    },

    rotate: async (organizationId: string): Promise<{ secret: string }> => {
        const result = await callable("rotateWebhookSecret")({ organizationId });
        return result.data as { secret: string };
    },

    getStatus: async (organizationId: string): Promise<WebhookSecretStatus> => {
        const result = await callable("getWebhookSecret")({ organizationId });
        return result.data as WebhookSecretStatus;
    },

    reveal: async (organizationId: string): Promise<{ secret: string }> => {
        const result = await callable("revealWebhookSecret")({ organizationId });
        return result.data as { secret: string };
    },
};

export default WebhookSecretService;